/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifySaasRouteImport } from './routes/verify-saas'
import { Route as SubdomainRouteImport } from './routes/subdomain'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterCompanyRouteImport } from './routes/register-company'
import { Route as RecoverPasswordRouteImport } from './routes/recover-password'
import { Route as PlatformRouteImport } from './routes/platform'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as PlatformIndexRouteImport } from './routes/platform/index'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index'
import { Route as PlatformUsageRouteImport } from './routes/platform/usage'
import { Route as PlatformSpacesRouteImport } from './routes/platform/spaces'
import { Route as PlatformPendingRegistrationsRouteImport } from './routes/platform/pending-registrations'
import { Route as PlatformLoginRouteImport } from './routes/platform/login'
import { Route as PlatformAuditLogsRouteImport } from './routes/platform/audit-logs'
import { Route as LayoutWorkScheduleRouteImport } from './routes/_layout/work-schedule'
import { Route as LayoutVacationsRouteImport } from './routes/_layout/vacations'
import { Route as LayoutUsersRouteImport } from './routes/_layout/users'
import { Route as LayoutTelemetryRouteImport } from './routes/_layout/telemetry'
import { Route as LayoutSettingsRouteImport } from './routes/_layout/settings'
import { Route as LayoutRoomsRouteImport } from './routes/_layout/rooms'
import { Route as LayoutPatternSchedulesRouteImport } from './routes/_layout/pattern-schedules'
import { Route as LayoutMyCompanyRouteImport } from './routes/_layout/my-company'
import { Route as LayoutEmployeesScheduleRouteImport } from './routes/_layout/employees-schedule'
import { Route as LayoutDocumentsRouteImport } from './routes/_layout/documents'
import { Route as LayoutDirectRouteImport } from './routes/_layout/direct'
import { Route as LayoutDepartmentsRouteImport } from './routes/_layout/departments'
import { Route as LayoutCompaniesRouteImport } from './routes/_layout/companies'
import { Route as PlatformSpacesIndexRouteImport } from './routes/platform/spaces/index'
import { Route as PlatformSpacesTenantIdRouteImport } from './routes/platform/spaces/$tenantId'
import { Route as LayoutUserUserIdRouteImport } from './routes/_layout/user/$userId'
import { Route as LayoutShiftEntriesListShiftEntriesRouteImport } from './routes/_layout/shift-entries-list/shift-entries'
import { Route as LayoutShiftEntriesListShiftIdRouteImport } from './routes/_layout/shift-entries-list/$shiftId'
import { Route as LayoutPatternSchedulePatternIdRouteImport } from './routes/_layout/pattern-schedule/$patternId'
import { Route as LayoutNewsCreateRouteImport } from './routes/_layout/news/create'
import { Route as LayoutNewsAllNewsRouteImport } from './routes/_layout/news/all-news'
import { Route as LayoutNewsNewsIdRouteImport } from './routes/_layout/news/$newsId'
import { Route as LayoutDepartmentDeptIdRouteImport } from './routes/_layout/department/$deptId'
import { Route as LayoutCompanyCompanyIdRouteImport } from './routes/_layout/company/$companyId'
import { Route as LayoutChatRoomIdRouteImport } from './routes/_layout/chat/$roomId'

const VerifySaasRoute = VerifySaasRouteImport.update({
  id: '/verify-saas',
  path: '/verify-saas',
  getParentRoute: () => rootRouteImport,
} as any)
const SubdomainRoute = SubdomainRouteImport.update({
  id: '/subdomain',
  path: '/subdomain',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterCompanyRoute = RegisterCompanyRouteImport.update({
  id: '/register-company',
  path: '/register-company',
  getParentRoute: () => rootRouteImport,
} as any)
const RecoverPasswordRoute = RecoverPasswordRouteImport.update({
  id: '/recover-password',
  path: '/recover-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformRoute = PlatformRouteImport.update({
  id: '/platform',
  path: '/platform',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformIndexRoute = PlatformIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PlatformRoute,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)
const PlatformUsageRoute = PlatformUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => PlatformRoute,
} as any)
const PlatformSpacesRoute = PlatformSpacesRouteImport.update({
  id: '/spaces',
  path: '/spaces',
  getParentRoute: () => PlatformRoute,
} as any)
const PlatformPendingRegistrationsRoute =
  PlatformPendingRegistrationsRouteImport.update({
    id: '/pending-registrations',
    path: '/pending-registrations',
    getParentRoute: () => PlatformRoute,
  } as any)
const PlatformLoginRoute = PlatformLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PlatformRoute,
} as any)
const PlatformAuditLogsRoute = PlatformAuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => PlatformRoute,
} as any)
const LayoutWorkScheduleRoute = LayoutWorkScheduleRouteImport.update({
  id: '/work-schedule',
  path: '/work-schedule',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutVacationsRoute = LayoutVacationsRouteImport.update({
  id: '/vacations',
  path: '/vacations',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutUsersRoute = LayoutUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTelemetryRoute = LayoutTelemetryRouteImport.update({
  id: '/telemetry',
  path: '/telemetry',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSettingsRoute = LayoutSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutRoomsRoute = LayoutRoomsRouteImport.update({
  id: '/rooms',
  path: '/rooms',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutPatternSchedulesRoute = LayoutPatternSchedulesRouteImport.update({
  id: '/pattern-schedules',
  path: '/pattern-schedules',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutMyCompanyRoute = LayoutMyCompanyRouteImport.update({
  id: '/my-company',
  path: '/my-company',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutEmployeesScheduleRoute = LayoutEmployeesScheduleRouteImport.update({
  id: '/employees-schedule',
  path: '/employees-schedule',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutDocumentsRoute = LayoutDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutDirectRoute = LayoutDirectRouteImport.update({
  id: '/direct',
  path: '/direct',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutDepartmentsRoute = LayoutDepartmentsRouteImport.update({
  id: '/departments',
  path: '/departments',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutCompaniesRoute = LayoutCompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => LayoutRoute,
} as any)
const PlatformSpacesIndexRoute = PlatformSpacesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PlatformSpacesRoute,
} as any)
const PlatformSpacesTenantIdRoute = PlatformSpacesTenantIdRouteImport.update({
  id: '/$tenantId',
  path: '/$tenantId',
  getParentRoute: () => PlatformSpacesRoute,
} as any)
const LayoutUserUserIdRoute = LayoutUserUserIdRouteImport.update({
  id: '/user/$userId',
  path: '/user/$userId',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutShiftEntriesListShiftEntriesRoute =
  LayoutShiftEntriesListShiftEntriesRouteImport.update({
    id: '/shift-entries-list/shift-entries',
    path: '/shift-entries-list/shift-entries',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutShiftEntriesListShiftIdRoute =
  LayoutShiftEntriesListShiftIdRouteImport.update({
    id: '/shift-entries-list/$shiftId',
    path: '/shift-entries-list/$shiftId',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutPatternSchedulePatternIdRoute =
  LayoutPatternSchedulePatternIdRouteImport.update({
    id: '/pattern-schedule/$patternId',
    path: '/pattern-schedule/$patternId',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutNewsCreateRoute = LayoutNewsCreateRouteImport.update({
  id: '/news/create',
  path: '/news/create',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutNewsAllNewsRoute = LayoutNewsAllNewsRouteImport.update({
  id: '/news/all-news',
  path: '/news/all-news',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutNewsNewsIdRoute = LayoutNewsNewsIdRouteImport.update({
  id: '/news/$newsId',
  path: '/news/$newsId',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutDepartmentDeptIdRoute = LayoutDepartmentDeptIdRouteImport.update({
  id: '/department/$deptId',
  path: '/department/$deptId',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutCompanyCompanyIdRoute = LayoutCompanyCompanyIdRouteImport.update({
  id: '/company/$companyId',
  path: '/company/$companyId',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutChatRoomIdRoute = LayoutChatRoomIdRouteImport.update({
  id: '/chat/$roomId',
  path: '/chat/$roomId',
  getParentRoute: () => LayoutRoute,
} as any)

export interface FileRoutesByFullPath {
  '/login': typeof LoginRoute
  '/platform': typeof PlatformRouteWithChildren
  '/recover-password': typeof RecoverPasswordRoute
  '/register-company': typeof RegisterCompanyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/subdomain': typeof SubdomainRoute
  '/verify-saas': typeof VerifySaasRoute
  '/companies': typeof LayoutCompaniesRoute
  '/departments': typeof LayoutDepartmentsRoute
  '/direct': typeof LayoutDirectRoute
  '/documents': typeof LayoutDocumentsRoute
  '/employees-schedule': typeof LayoutEmployeesScheduleRoute
  '/my-company': typeof LayoutMyCompanyRoute
  '/pattern-schedules': typeof LayoutPatternSchedulesRoute
  '/rooms': typeof LayoutRoomsRoute
  '/settings': typeof LayoutSettingsRoute
  '/telemetry': typeof LayoutTelemetryRoute
  '/users': typeof LayoutUsersRoute
  '/vacations': typeof LayoutVacationsRoute
  '/work-schedule': typeof LayoutWorkScheduleRoute
  '/platform/audit-logs': typeof PlatformAuditLogsRoute
  '/platform/login': typeof PlatformLoginRoute
  '/platform/pending-registrations': typeof PlatformPendingRegistrationsRoute
  '/platform/spaces': typeof PlatformSpacesRouteWithChildren
  '/platform/usage': typeof PlatformUsageRoute
  '/': typeof LayoutIndexRoute
  '/platform/': typeof PlatformIndexRoute
  '/chat/$roomId': typeof LayoutChatRoomIdRoute
  '/company/$companyId': typeof LayoutCompanyCompanyIdRoute
  '/department/$deptId': typeof LayoutDepartmentDeptIdRoute
  '/news/$newsId': typeof LayoutNewsNewsIdRoute
  '/news/all-news': typeof LayoutNewsAllNewsRoute
  '/news/create': typeof LayoutNewsCreateRoute
  '/pattern-schedule/$patternId': typeof LayoutPatternSchedulePatternIdRoute
  '/shift-entries-list/$shiftId': typeof LayoutShiftEntriesListShiftIdRoute
  '/shift-entries-list/shift-entries': typeof LayoutShiftEntriesListShiftEntriesRoute
  '/user/$userId': typeof LayoutUserUserIdRoute
  '/platform/spaces/$tenantId': typeof PlatformSpacesTenantIdRoute
  '/platform/spaces/': typeof PlatformSpacesIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/register-company': typeof RegisterCompanyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/subdomain': typeof SubdomainRoute
  '/verify-saas': typeof VerifySaasRoute
  '/companies': typeof LayoutCompaniesRoute
  '/departments': typeof LayoutDepartmentsRoute
  '/direct': typeof LayoutDirectRoute
  '/documents': typeof LayoutDocumentsRoute
  '/employees-schedule': typeof LayoutEmployeesScheduleRoute
  '/my-company': typeof LayoutMyCompanyRoute
  '/pattern-schedules': typeof LayoutPatternSchedulesRoute
  '/rooms': typeof LayoutRoomsRoute
  '/settings': typeof LayoutSettingsRoute
  '/telemetry': typeof LayoutTelemetryRoute
  '/users': typeof LayoutUsersRoute
  '/vacations': typeof LayoutVacationsRoute
  '/work-schedule': typeof LayoutWorkScheduleRoute
  '/platform/audit-logs': typeof PlatformAuditLogsRoute
  '/platform/login': typeof PlatformLoginRoute
  '/platform/pending-registrations': typeof PlatformPendingRegistrationsRoute
  '/platform/usage': typeof PlatformUsageRoute
  '/': typeof LayoutIndexRoute
  '/platform': typeof PlatformIndexRoute
  '/chat/$roomId': typeof LayoutChatRoomIdRoute
  '/company/$companyId': typeof LayoutCompanyCompanyIdRoute
  '/department/$deptId': typeof LayoutDepartmentDeptIdRoute
  '/news/$newsId': typeof LayoutNewsNewsIdRoute
  '/news/all-news': typeof LayoutNewsAllNewsRoute
  '/news/create': typeof LayoutNewsCreateRoute
  '/pattern-schedule/$patternId': typeof LayoutPatternSchedulePatternIdRoute
  '/shift-entries-list/$shiftId': typeof LayoutShiftEntriesListShiftIdRoute
  '/shift-entries-list/shift-entries': typeof LayoutShiftEntriesListShiftEntriesRoute
  '/user/$userId': typeof LayoutUserUserIdRoute
  '/platform/spaces/$tenantId': typeof PlatformSpacesTenantIdRoute
  '/platform/spaces': typeof PlatformSpacesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_layout': typeof LayoutRouteWithChildren
  '/login': typeof LoginRoute
  '/platform': typeof PlatformRouteWithChildren
  '/recover-password': typeof RecoverPasswordRoute
  '/register-company': typeof RegisterCompanyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/subdomain': typeof SubdomainRoute
  '/verify-saas': typeof VerifySaasRoute
  '/_layout/companies': typeof LayoutCompaniesRoute
  '/_layout/departments': typeof LayoutDepartmentsRoute
  '/_layout/direct': typeof LayoutDirectRoute
  '/_layout/documents': typeof LayoutDocumentsRoute
  '/_layout/employees-schedule': typeof LayoutEmployeesScheduleRoute
  '/_layout/my-company': typeof LayoutMyCompanyRoute
  '/_layout/pattern-schedules': typeof LayoutPatternSchedulesRoute
  '/_layout/rooms': typeof LayoutRoomsRoute
  '/_layout/settings': typeof LayoutSettingsRoute
  '/_layout/telemetry': typeof LayoutTelemetryRoute
  '/_layout/users': typeof LayoutUsersRoute
  '/_layout/vacations': typeof LayoutVacationsRoute
  '/_layout/work-schedule': typeof LayoutWorkScheduleRoute
  '/platform/audit-logs': typeof PlatformAuditLogsRoute
  '/platform/login': typeof PlatformLoginRoute
  '/platform/pending-registrations': typeof PlatformPendingRegistrationsRoute
  '/platform/spaces': typeof PlatformSpacesRouteWithChildren
  '/platform/usage': typeof PlatformUsageRoute
  '/_layout/': typeof LayoutIndexRoute
  '/platform/': typeof PlatformIndexRoute
  '/_layout/chat/$roomId': typeof LayoutChatRoomIdRoute
  '/_layout/company/$companyId': typeof LayoutCompanyCompanyIdRoute
  '/_layout/department/$deptId': typeof LayoutDepartmentDeptIdRoute
  '/_layout/news/$newsId': typeof LayoutNewsNewsIdRoute
  '/_layout/news/all-news': typeof LayoutNewsAllNewsRoute
  '/_layout/news/create': typeof LayoutNewsCreateRoute
  '/_layout/pattern-schedule/$patternId': typeof LayoutPatternSchedulePatternIdRoute
  '/_layout/shift-entries-list/$shiftId': typeof LayoutShiftEntriesListShiftIdRoute
  '/_layout/shift-entries-list/shift-entries': typeof LayoutShiftEntriesListShiftEntriesRoute
  '/_layout/user/$userId': typeof LayoutUserUserIdRoute
  '/platform/spaces/$tenantId': typeof PlatformSpacesTenantIdRoute
  '/platform/spaces/': typeof PlatformSpacesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/login'
    | '/platform'
    | '/recover-password'
    | '/register-company'
    | '/reset-password'
    | '/signup'
    | '/subdomain'
    | '/verify-saas'
    | '/companies'
    | '/departments'
    | '/direct'
    | '/documents'
    | '/employees-schedule'
    | '/my-company'
    | '/pattern-schedules'
    | '/rooms'
    | '/settings'
    | '/telemetry'
    | '/users'
    | '/vacations'
    | '/work-schedule'
    | '/platform/audit-logs'
    | '/platform/login'
    | '/platform/pending-registrations'
    | '/platform/spaces'
    | '/platform/usage'
    | '/'
    | '/platform/'
    | '/chat/$roomId'
    | '/company/$companyId'
    | '/department/$deptId'
    | '/news/$newsId'
    | '/news/all-news'
    | '/news/create'
    | '/pattern-schedule/$patternId'
    | '/shift-entries-list/$shiftId'
    | '/shift-entries-list/shift-entries'
    | '/user/$userId'
    | '/platform/spaces/$tenantId'
    | '/platform/spaces/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/recover-password'
    | '/register-company'
    | '/reset-password'
    | '/signup'
    | '/subdomain'
    | '/verify-saas'
    | '/companies'
    | '/departments'
    | '/direct'
    | '/documents'
    | '/employees-schedule'
    | '/my-company'
    | '/pattern-schedules'
    | '/rooms'
    | '/settings'
    | '/telemetry'
    | '/users'
    | '/vacations'
    | '/work-schedule'
    | '/platform/audit-logs'
    | '/platform/login'
    | '/platform/pending-registrations'
    | '/platform/usage'
    | '/'
    | '/platform'
    | '/chat/$roomId'
    | '/company/$companyId'
    | '/department/$deptId'
    | '/news/$newsId'
    | '/news/all-news'
    | '/news/create'
    | '/pattern-schedule/$patternId'
    | '/shift-entries-list/$shiftId'
    | '/shift-entries-list/shift-entries'
    | '/user/$userId'
    | '/platform/spaces/$tenantId'
    | '/platform/spaces'
  id:
    | '__root__'
    | '/_layout'
    | '/login'
    | '/platform'
    | '/recover-password'
    | '/register-company'
    | '/reset-password'
    | '/signup'
    | '/subdomain'
    | '/verify-saas'
    | '/_layout/companies'
    | '/_layout/departments'
    | '/_layout/direct'
    | '/_layout/documents'
    | '/_layout/employees-schedule'
    | '/_layout/my-company'
    | '/_layout/pattern-schedules'
    | '/_layout/rooms'
    | '/_layout/settings'
    | '/_layout/telemetry'
    | '/_layout/users'
    | '/_layout/vacations'
    | '/_layout/work-schedule'
    | '/platform/audit-logs'
    | '/platform/login'
    | '/platform/pending-registrations'
    | '/platform/spaces'
    | '/platform/usage'
    | '/_layout/'
    | '/platform/'
    | '/_layout/chat/$roomId'
    | '/_layout/company/$companyId'
    | '/_layout/department/$deptId'
    | '/_layout/news/$newsId'
    | '/_layout/news/all-news'
    | '/_layout/news/create'
    | '/_layout/pattern-schedule/$patternId'
    | '/_layout/shift-entries-list/$shiftId'
    | '/_layout/shift-entries-list/shift-entries'
    | '/_layout/user/$userId'
    | '/platform/spaces/$tenantId'
    | '/platform/spaces/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
  LoginRoute: typeof LoginRoute
  PlatformRoute: typeof PlatformRouteWithChildren
  RecoverPasswordRoute: typeof RecoverPasswordRoute
  RegisterCompanyRoute: typeof RegisterCompanyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  SubdomainRoute: typeof SubdomainRoute
  VerifySaasRoute: typeof VerifySaasRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-saas': {
      id: '/verify-saas'
      path: '/verify-saas'
      fullPath: '/verify-saas'
      preLoaderRoute: typeof VerifySaasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subdomain': {
      id: '/subdomain'
      path: '/subdomain'
      fullPath: '/subdomain'
      preLoaderRoute: typeof SubdomainRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register-company': {
      id: '/register-company'
      path: '/register-company'
      fullPath: '/register-company'
      preLoaderRoute: typeof RegisterCompanyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recover-password': {
      id: '/recover-password'
      path: '/recover-password'
      fullPath: '/recover-password'
      preLoaderRoute: typeof RecoverPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform': {
      id: '/platform'
      path: '/platform'
      fullPath: '/platform'
      preLoaderRoute: typeof PlatformRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/': {
      id: '/platform/'
      path: '/'
      fullPath: '/platform/'
      preLoaderRoute: typeof PlatformIndexRouteImport
      parentRoute: typeof PlatformRoute
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/platform/usage': {
      id: '/platform/usage'
      path: '/usage'
      fullPath: '/platform/usage'
      preLoaderRoute: typeof PlatformUsageRouteImport
      parentRoute: typeof PlatformRoute
    }
    '/platform/spaces': {
      id: '/platform/spaces'
      path: '/spaces'
      fullPath: '/platform/spaces'
      preLoaderRoute: typeof PlatformSpacesRouteImport
      parentRoute: typeof PlatformRoute
    }
    '/platform/pending-registrations': {
      id: '/platform/pending-registrations'
      path: '/pending-registrations'
      fullPath: '/platform/pending-registrations'
      preLoaderRoute: typeof PlatformPendingRegistrationsRouteImport
      parentRoute: typeof PlatformRoute
    }
    '/platform/login': {
      id: '/platform/login'
      path: '/login'
      fullPath: '/platform/login'
      preLoaderRoute: typeof PlatformLoginRouteImport
      parentRoute: typeof PlatformRoute
    }
    '/platform/audit-logs': {
      id: '/platform/audit-logs'
      path: '/audit-logs'
      fullPath: '/platform/audit-logs'
      preLoaderRoute: typeof PlatformAuditLogsRouteImport
      parentRoute: typeof PlatformRoute
    }
    '/_layout/work-schedule': {
      id: '/_layout/work-schedule'
      path: '/work-schedule'
      fullPath: '/work-schedule'
      preLoaderRoute: typeof LayoutWorkScheduleRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/vacations': {
      id: '/_layout/vacations'
      path: '/vacations'
      fullPath: '/vacations'
      preLoaderRoute: typeof LayoutVacationsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/users': {
      id: '/_layout/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof LayoutUsersRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/telemetry': {
      id: '/_layout/telemetry'
      path: '/telemetry'
      fullPath: '/telemetry'
      preLoaderRoute: typeof LayoutTelemetryRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/settings': {
      id: '/_layout/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof LayoutSettingsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/rooms': {
      id: '/_layout/rooms'
      path: '/rooms'
      fullPath: '/rooms'
      preLoaderRoute: typeof LayoutRoomsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/pattern-schedules': {
      id: '/_layout/pattern-schedules'
      path: '/pattern-schedules'
      fullPath: '/pattern-schedules'
      preLoaderRoute: typeof LayoutPatternSchedulesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/my-company': {
      id: '/_layout/my-company'
      path: '/my-company'
      fullPath: '/my-company'
      preLoaderRoute: typeof LayoutMyCompanyRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/employees-schedule': {
      id: '/_layout/employees-schedule'
      path: '/employees-schedule'
      fullPath: '/employees-schedule'
      preLoaderRoute: typeof LayoutEmployeesScheduleRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/documents': {
      id: '/_layout/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof LayoutDocumentsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/direct': {
      id: '/_layout/direct'
      path: '/direct'
      fullPath: '/direct'
      preLoaderRoute: typeof LayoutDirectRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/departments': {
      id: '/_layout/departments'
      path: '/departments'
      fullPath: '/departments'
      preLoaderRoute: typeof LayoutDepartmentsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/companies': {
      id: '/_layout/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof LayoutCompaniesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/platform/spaces/': {
      id: '/platform/spaces/'
      path: '/'
      fullPath: '/platform/spaces/'
      preLoaderRoute: typeof PlatformSpacesIndexRouteImport
      parentRoute: typeof PlatformSpacesRoute
    }
    '/platform/spaces/$tenantId': {
      id: '/platform/spaces/$tenantId'
      path: '/$tenantId'
      fullPath: '/platform/spaces/$tenantId'
      preLoaderRoute: typeof PlatformSpacesTenantIdRouteImport
      parentRoute: typeof PlatformSpacesRoute
    }
    '/_layout/user/$userId': {
      id: '/_layout/user/$userId'
      path: '/user/$userId'
      fullPath: '/user/$userId'
      preLoaderRoute: typeof LayoutUserUserIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/shift-entries-list/shift-entries': {
      id: '/_layout/shift-entries-list/shift-entries'
      path: '/shift-entries-list/shift-entries'
      fullPath: '/shift-entries-list/shift-entries'
      preLoaderRoute: typeof LayoutShiftEntriesListShiftEntriesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/shift-entries-list/$shiftId': {
      id: '/_layout/shift-entries-list/$shiftId'
      path: '/shift-entries-list/$shiftId'
      fullPath: '/shift-entries-list/$shiftId'
      preLoaderRoute: typeof LayoutShiftEntriesListShiftIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/pattern-schedule/$patternId': {
      id: '/_layout/pattern-schedule/$patternId'
      path: '/pattern-schedule/$patternId'
      fullPath: '/pattern-schedule/$patternId'
      preLoaderRoute: typeof LayoutPatternSchedulePatternIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/news/create': {
      id: '/_layout/news/create'
      path: '/news/create'
      fullPath: '/news/create'
      preLoaderRoute: typeof LayoutNewsCreateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/news/all-news': {
      id: '/_layout/news/all-news'
      path: '/news/all-news'
      fullPath: '/news/all-news'
      preLoaderRoute: typeof LayoutNewsAllNewsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/news/$newsId': {
      id: '/_layout/news/$newsId'
      path: '/news/$newsId'
      fullPath: '/news/$newsId'
      preLoaderRoute: typeof LayoutNewsNewsIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/department/$deptId': {
      id: '/_layout/department/$deptId'
      path: '/department/$deptId'
      fullPath: '/department/$deptId'
      preLoaderRoute: typeof LayoutDepartmentDeptIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/company/$companyId': {
      id: '/_layout/company/$companyId'
      path: '/company/$companyId'
      fullPath: '/company/$companyId'
      preLoaderRoute: typeof LayoutCompanyCompanyIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/chat/$roomId': {
      id: '/_layout/chat/$roomId'
      path: '/chat/$roomId'
      fullPath: '/chat/$roomId'
      preLoaderRoute: typeof LayoutChatRoomIdRouteImport
      parentRoute: typeof LayoutRoute
    }
  }
}

interface LayoutRouteChildren {
  LayoutCompaniesRoute: typeof LayoutCompaniesRoute
  LayoutDepartmentsRoute: typeof LayoutDepartmentsRoute
  LayoutDirectRoute: typeof LayoutDirectRoute
  LayoutDocumentsRoute: typeof LayoutDocumentsRoute
  LayoutEmployeesScheduleRoute: typeof LayoutEmployeesScheduleRoute
  LayoutMyCompanyRoute: typeof LayoutMyCompanyRoute
  LayoutPatternSchedulesRoute: typeof LayoutPatternSchedulesRoute
  LayoutRoomsRoute: typeof LayoutRoomsRoute
  LayoutSettingsRoute: typeof LayoutSettingsRoute
  LayoutTelemetryRoute: typeof LayoutTelemetryRoute
  LayoutUsersRoute: typeof LayoutUsersRoute
  LayoutVacationsRoute: typeof LayoutVacationsRoute
  LayoutWorkScheduleRoute: typeof LayoutWorkScheduleRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutChatRoomIdRoute: typeof LayoutChatRoomIdRoute
  LayoutCompanyCompanyIdRoute: typeof LayoutCompanyCompanyIdRoute
  LayoutDepartmentDeptIdRoute: typeof LayoutDepartmentDeptIdRoute
  LayoutNewsNewsIdRoute: typeof LayoutNewsNewsIdRoute
  LayoutNewsAllNewsRoute: typeof LayoutNewsAllNewsRoute
  LayoutNewsCreateRoute: typeof LayoutNewsCreateRoute
  LayoutPatternSchedulePatternIdRoute: typeof LayoutPatternSchedulePatternIdRoute
  LayoutShiftEntriesListShiftIdRoute: typeof LayoutShiftEntriesListShiftIdRoute
  LayoutShiftEntriesListShiftEntriesRoute: typeof LayoutShiftEntriesListShiftEntriesRoute
  LayoutUserUserIdRoute: typeof LayoutUserUserIdRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutCompaniesRoute: LayoutCompaniesRoute,
  LayoutDepartmentsRoute: LayoutDepartmentsRoute,
  LayoutDirectRoute: LayoutDirectRoute,
  LayoutDocumentsRoute: LayoutDocumentsRoute,
  LayoutEmployeesScheduleRoute: LayoutEmployeesScheduleRoute,
  LayoutMyCompanyRoute: LayoutMyCompanyRoute,
  LayoutPatternSchedulesRoute: LayoutPatternSchedulesRoute,
  LayoutRoomsRoute: LayoutRoomsRoute,
  LayoutSettingsRoute: LayoutSettingsRoute,
  LayoutTelemetryRoute: LayoutTelemetryRoute,
  LayoutUsersRoute: LayoutUsersRoute,
  LayoutVacationsRoute: LayoutVacationsRoute,
  LayoutWorkScheduleRoute: LayoutWorkScheduleRoute,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutChatRoomIdRoute: LayoutChatRoomIdRoute,
  LayoutCompanyCompanyIdRoute: LayoutCompanyCompanyIdRoute,
  LayoutDepartmentDeptIdRoute: LayoutDepartmentDeptIdRoute,
  LayoutNewsNewsIdRoute: LayoutNewsNewsIdRoute,
  LayoutNewsAllNewsRoute: LayoutNewsAllNewsRoute,
  LayoutNewsCreateRoute: LayoutNewsCreateRoute,
  LayoutPatternSchedulePatternIdRoute: LayoutPatternSchedulePatternIdRoute,
  LayoutShiftEntriesListShiftIdRoute: LayoutShiftEntriesListShiftIdRoute,
  LayoutShiftEntriesListShiftEntriesRoute:
    LayoutShiftEntriesListShiftEntriesRoute,
  LayoutUserUserIdRoute: LayoutUserUserIdRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

interface PlatformSpacesRouteChildren {
  PlatformSpacesTenantIdRoute: typeof PlatformSpacesTenantIdRoute
  PlatformSpacesIndexRoute: typeof PlatformSpacesIndexRoute
}

const PlatformSpacesRouteChildren: PlatformSpacesRouteChildren = {
  PlatformSpacesTenantIdRoute: PlatformSpacesTenantIdRoute,
  PlatformSpacesIndexRoute: PlatformSpacesIndexRoute,
}

const PlatformSpacesRouteWithChildren = PlatformSpacesRoute._addFileChildren(
  PlatformSpacesRouteChildren,
)

interface PlatformRouteChildren {
  PlatformAuditLogsRoute: typeof PlatformAuditLogsRoute
  PlatformLoginRoute: typeof PlatformLoginRoute
  PlatformPendingRegistrationsRoute: typeof PlatformPendingRegistrationsRoute
  PlatformSpacesRoute: typeof PlatformSpacesRouteWithChildren
  PlatformUsageRoute: typeof PlatformUsageRoute
  PlatformIndexRoute: typeof PlatformIndexRoute
}

const PlatformRouteChildren: PlatformRouteChildren = {
  PlatformAuditLogsRoute: PlatformAuditLogsRoute,
  PlatformLoginRoute: PlatformLoginRoute,
  PlatformPendingRegistrationsRoute: PlatformPendingRegistrationsRoute,
  PlatformSpacesRoute: PlatformSpacesRouteWithChildren,
  PlatformUsageRoute: PlatformUsageRoute,
  PlatformIndexRoute: PlatformIndexRoute,
}

const PlatformRouteWithChildren = PlatformRoute._addFileChildren(
  PlatformRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
  LoginRoute: LoginRoute,
  PlatformRoute: PlatformRouteWithChildren,
  RecoverPasswordRoute: RecoverPasswordRoute,
  RegisterCompanyRoute: RegisterCompanyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  SubdomainRoute: SubdomainRoute,
  VerifySaasRoute: VerifySaasRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
